// extracted by mini-css-extract-plugin
export default {"sellingPoint":"selling-points-module--sellingPoint--qQhlx"};